<div class="sidenav-content">
  <div class="bcontainer2">
    <div class="main-content">
      <div class="spacer2"></div>

      <div class="containter">
        <div class="mfhd">
          <i class="fa fa-angle-left" aria-hidden="true" style="padding-right: 5px; cursor: pointer" (click)="goBack()"
            tabindex="0" role="button" aria-label="Go back" (keydown.enter)="goBack()"></i>
          Chat
          <div class="page-description" style="
              color: #9c9b9b;
              font-size: 14px;
              margin-top: 8px;
              margin-bottom: 16px;
            ">
            Search and interact with memories for this user.
          </div>
        </div>

        <!-- Memory Processing Status Indicator -->
        <div class="memory-status-indicator" *ngIf="memoryQueueCount > 0"
          title="Memories being processed: {{ memoryQueueCount }}" (click)="refreshMemoryStatus()">
          <div class="memory-status-pulse"></div>
          <i class="fa-solid fa-microchip"></i>
          <span class="memory-status-count">{{ memoryQueueCount }}</span>
          <span class="memory-status-text">processing</span>
        </div>

        <div class="chat-container" role="main" aria-label="Memory chat interface">
          <!-- Chat Messages Area -->
          <div class="chat-messages" #messagesContainer role="log" aria-live="polite" aria-atomic="false">
            <!-- Initial State -->
            <div *ngIf="messages.length === 0 && !loading" class="initial-state">
              <i class="fa-solid fa-comments" aria-hidden="true"></i>
              <h3>Start a conversation</h3>
              <p>Ask me to search through memories, or try one of these shortcuts:</p>

              <!-- Chat Shortcuts -->
              <div class="chat-shortcuts">
                <button class="shortcut-btn" (click)="executeShortcut('list all memories')"
                  aria-label="List all memories">
                  <i class="fa-solid fa-list" aria-hidden="true"></i>
                  <span>List all memories</span>
                </button>

                <button class="shortcut-btn" (click)="executeShortcut('list all tags')" aria-label="List all tags">
                  <i class="fa-solid fa-tags" aria-hidden="true"></i>
                  <span>List all tags</span>
                </button>

                <button class="shortcut-btn" (click)="openMcpConfig()" aria-label="Configure MCP">
                  <i class="fa-solid fa-plug" aria-hidden="true"></i>
                  <span>Configure MCP</span>
                </button>

                <button class="shortcut-btn" (click)="openChromeConfig()" aria-label="Configure Chrome Extension">
                  <i class="fa-brands fa-chrome" aria-hidden="true"></i>
                  <span>Configure Chrome</span>
                </button>

                <button class="shortcut-btn" (click)="showChromeOtp()" aria-label="Show Chrome OTP">
                  <i class="fa-solid fa-key" aria-hidden="true"></i>
                  <span>Show Chrome OTP</span>
                </button>
              </div>
            </div>

            <!-- Messages -->
            <ng-container *ngFor="let message of messages; let i = index">
              <!-- User Message -->
              <div *ngIf="message.type === 'user'" class="message user" role="article" aria-label="Your message"
                [attr.tabindex]="0">
                <div class="message-avatar" [attr.data-initial]="getUserInitial()">
                  {{ getUserInitial() }}
                </div>
                <div class="message-content">
                  <div class="message-bubble">
                    <p class="message-text">{{ message.text }}</p>
                  </div>
                </div>
              </div>

              <!-- Assistant Message -->
              <div *ngIf="message.type === 'assistant'" class="message assistant" role="article"
                aria-label="Assistant response" [attr.tabindex]="0">
                <div class="message-avatar">
                  <!-- Robot emoji rendered via CSS ::before -->
                </div>
                <div class="message-content">
                  <div class="message-bubble" [class.success]="message.messageType === 'success'"
                    [class.warning]="message.messageType === 'warning'" [class.error]="message.messageType === 'error'"
                    [class.orchestrating]="message.isOrchestrating">

                    <!-- ============================================
                         ORCHESTRATION - Typewriter Activity Display
                         ============================================ -->
                    <div *ngIf="message.orchestrationSteps?.length" class="orchestration-steps">
                      <ng-container *ngFor="let step of message.orchestrationSteps">
                        <!-- Only show active step -->
                        <div *ngIf="step.status === 'active'" class="orchestration-step active">
                          <span class="step-text">{{ step.text }}</span>
                        </div>
                        <!-- Show error step -->
                        <div *ngIf="step.status === 'error'" class="orchestration-step error">
                          <span class="step-text">{{ step.text }}</span>
                        </div>
                      </ng-container>
                    </div>

                    <!-- ============================================
                         SKELETON LOADERS - Show while fetching data
                         ============================================ -->
                    <div *ngIf="message.showSkeletons" class="skeleton-container">
                      <div class="memory-skeleton"></div>
                      <div class="memory-skeleton"></div>
                      <div class="memory-skeleton"></div>
                    </div>

                    <!-- ============================================
                         ACTUAL CONTENT (only when not orchestrating)
                         ============================================ -->
                    <ng-container *ngIf="!message.isOrchestrating && !message.showSkeletons">

                      <!-- Display Mode Badge -->
                      <div class="display-mode-badge"
                        *ngIf="message.displayMode && !message.orchestrationSteps?.length && !message.createdMemory">
                        <i class="fa-solid fa-{{ message.displayMode === 'raw' ? 'database' : message.displayMode === 'summary' ? 'lightbulb' : message.displayMode === 'summary_external' ? 'cloud' : 'sparkles' }}"
                          aria-hidden="true"></i>
                        {{ message.displayMode === 'raw' ? 'Raw Memory' : message.displayMode === 'summary' ? 'Summary'
                        : message.displayMode === 'summary_external' ? 'External Summary' : 'Summarized' }}
                      </div>

                      <!-- ============================================
                           CREATED MEMORY DISPLAY - New Section
                           ============================================ -->
                      <div *ngIf="message.createdMemory" class="created-memory-result">
                        <div class="created-memory-header">
                          <i class="fa-solid fa-check-circle" aria-hidden="true"></i>
                          <span>Memory Created Successfully</span>
                        </div>
                        <div class="created-memory-content">
                          <div class="created-memory-text">
                            "{{ message.createdMemory.content }}"
                          </div>
                          <div class="created-memory-meta" *ngIf="message.createdMemory.processId">
                            <span class="meta-label">Process ID:</span>
                            <code class="meta-value">{{ message.createdMemory.processId }}</code>
                          </div>
                        </div>
                        <div class="created-memory-note">
                          <i class="fa-solid fa-info-circle" aria-hidden="true"></i>
                          <span>Your memory has been added to the processing queue and will be available shortly.</span>
                        </div>
                      </div>

                      <!-- Simple text message (like status updates) -->
                      <p class="message-text"
                        *ngIf="!message.tags && !message.memories && !message.totalMemories && !message.createdMemory && message.text">
                        {{ message.text }}
                      </p>

                      <!-- Inline Shortcuts (shown in welcome message) -->
                      <div class="inline-shortcuts"
                        *ngIf="message.showShortcuts && !message.tags && !message.memories && !message.totalMemories && !message.createdMemory">
                        <button class="inline-shortcut-btn" (click)="listAllMemories()" [disabled]="loading"
                          aria-label="List all memories">
                          <i class="fa-solid fa-list" aria-hidden="true"></i>
                          <span>List All Memories</span>
                        </button>

                        <button class="inline-shortcut-btn" (click)="listAllTags()" [disabled]="loading"
                          aria-label="List all tags">
                          <i class="fa-solid fa-tags" aria-hidden="true"></i>
                          <span>List All Tags</span>
                        </button>

                        <button class="inline-shortcut-btn" (click)="openMcpConfig()" [disabled]="loading"
                          aria-label="Configure MCP">
                          <i class="fa-solid fa-plug" aria-hidden="true"></i>
                          <span>MCP Configuration</span>
                        </button>

                        <button class="inline-shortcut-btn" (click)="openChromeConfig()" [disabled]="loading"
                          aria-label="Configure Chrome Extension">
                          <i class="fa-brands fa-chrome" aria-hidden="true"></i>
                          <span>Chrome Extension</span>
                        </button>

                        <button class="inline-shortcut-btn" (click)="showChromeOtp()" [disabled]="loading"
                          aria-label="Show Chrome OTP">
                          <i class="fa-solid fa-key" aria-hidden="true"></i>
                          <span>Show OTP Code</span>
                        </button>
                      </div>

                      <!-- Search query display -->
                      <p class="message-text"
                        *ngIf="(message.memories !== undefined || message.totalMemories !== undefined) && !message.orchestrationSteps?.length">
                        <ng-container *ngIf="message.text === 'all memories'">
                          Here are all the memories
                        </ng-container>
                        <ng-container *ngIf="message.text === 'all tags'">
                          Here are all the tags
                        </ng-container>
                        <ng-container *ngIf="message.text.startsWith('tag:')">
                          Memories with {{ message.text }}
                        </ng-container>
                        <ng-container *ngIf="message.text.startsWith('token:')">
                          Memories with {{ message.text }}
                        </ng-container>
                        <ng-container
                          *ngIf="message.text !== 'all memories' && message.text !== 'all tags' && !message.text.startsWith('tag:') && !message.text.startsWith('token:')">
                          Searching for: "{{ message.text }}"
                        </ng-container>
                      </p>

                      <!-- Memory Results -->
                      <div class="memory-results" *ngIf="message.totalMemories !== undefined">
                        <!-- Collapsible Header -->
                        <div class="memory-collapse-header" (click)="toggleMemoryCollapse(message)">
                          <div class="collapse-header-left">
                            <i class="fa-solid"
                              [ngClass]="message.isCollapsed !== false ? 'fa-chevron-right' : 'fa-chevron-down'"></i>
                            <span class="results-count-inline">
                              Found {{ message.totalMemories }} {{ message.totalMemories === 1 ? 'memory' : 'memories'
                              }}
                            </span>
                          </div>
                          <span class="collapse-hint">
                            {{ message.isCollapsed !== false ? 'Click to expand' : 'Click to collapse' }}
                          </span>
                        </div>

                        <!-- Collapsible Content Wrapper -->
                        <div class="memory-collapse-content" [class.collapsed]="message.isCollapsed !== false">
                          <div class="results-count" role="status" aria-live="polite"
                            *ngIf="!message.orchestrationSteps?.length">
                            Found {{ message.totalMemories }}
                            {{ message.totalMemories === 1 ? 'memory' : 'memories' }}
                          </div>

                          <!-- Memories List -->
                          <div *ngFor="let memory of message.memories; trackBy: trackByMemoryId; let memIndex = index"
                            class="memory-card-inline" [style.animation-delay]="(memIndex * 0.05) + 's'" role="article"
                            [attr.aria-label]="'Memory entry'">
                            <!-- Memory Image (if available) -->
                            <div class="memory-image-container" *ngIf="memory.imageDataBase64">
                              <img
                                [src]="'data:' + (memory.imageMimeType || 'image/png') + ';base64,' + memory.imageDataBase64"
                                [alt]="memory.imageFileName || 'Memory image'" class="memory-image" loading="lazy"
                                (error)="handleImageError($event)" />
                              <div class="memory-image-filename" *ngIf="memory.imageFileName">
                                <i class="fa-solid fa-image" aria-hidden="true"></i>
                                {{ memory.imageFileName }}
                              </div>
                            </div>

                            <!-- Memory Content with Inline Actions -->
                            <div class="memory-inline-container">
                              <!-- Sensitivity Badge (shown for HIGH/CRITICAL memories) -->
                              <span *ngIf="isSensitiveMemory(memory)" class="memory-sensitivity-badge"
                                [class.critical]="memory.sensitivity?.toUpperCase() === 'CRITICAL'"
                                [title]="getSensitivityLabel(memory) + ' sensitivity'">
                                <i class="fa-solid" [ngClass]="getSensitivityIcon(memory)" aria-hidden="true"></i>
                              </span>

                              <!-- Main content - Shows masked or clear based on sensitivity/reveal state -->
                              <div class="memory-content-inline"
                                [class.masked]="isSensitiveMemory(memory) && !isMemoryRevealed(memory)"
                                (click)="onMemoryContentClick($event, memory.tokens)">

                                <!-- Revealed or non-sensitive content with token highlighting -->
                                <ng-container *ngIf="!isSensitiveMemory(memory) || isMemoryRevealed(memory)">
                                  <span [innerHTML]="highlightTokens(memory.memory, memory.tokens)"></span>
                                </ng-container>

                                <!-- Masked content for sensitive unrevealed memories -->
                                <ng-container *ngIf="isSensitiveMemory(memory) && !isMemoryRevealed(memory)">
                                  <span class="masked-content">{{ getMaskedMemoryContent(memory) }}</span>
                                </ng-container>
                              </div>

                              <!-- Reveal/Hide Button for sensitive memories -->
                              <button *ngIf="isSensitiveMemory(memory)" class="memory-inline-btn memory-reveal-btn"
                                [class.revealed]="isMemoryRevealed(memory)" (click)="toggleMemoryReveal(memory, $event)"
                                [title]="isMemoryRevealed(memory) ? 'Hide sensitive content' : 'Reveal sensitive content'"
                                aria-label="Toggle sensitive content visibility">
                                <i class="fa-solid"
                                  [ngClass]="isMemoryRevealed(memory) ? 'fa-eye-slash' : 'fa-eye'"></i>
                              </button>

                              <!-- Inline Tag & Actions -->
                              <div class="memory-inline-actions">
                                <!-- Tag Display/Edit -->
                                <span class="memory-inline-tag-wrapper">
                                  <!-- View Mode: Just the tag, inline -->
                                  <span *ngIf="!isEditingMemoryTag(memory) && memory.notesKey" class="memory-inline-tag"
                                    [title]="'Key: ' + memory.notesKey"
                                    (click)="searchMemoriesByTag(memory.notesKey); $event.stopPropagation()">
                                    {{ memory.notesKey }}
                                  </span>

                                  <!-- Edit Mode: Inline input -->
                                  <span *ngIf="isEditingMemoryTag(memory)" class="memory-inline-tag-edit">
                                    <input type="text" class="memory-inline-tag-input"
                                      [(ngModel)]="editingMemoryTagValue" [placeholder]="memory.notesKey || 'tag'"
                                      (keydown.enter)="saveMemoryTagEdit(memory)"
                                      (keydown.escape)="cancelMemoryTagEdit()" (click)="$event.stopPropagation()"
                                      [disabled]="loading" maxlength="30" />
                                  </span>

                                  <!-- No tag: Show on hover only -->
                                  <span *ngIf="!isEditingMemoryTag(memory) && !memory.notesKey"
                                    class="memory-inline-tag-empty" title="Add tag">
                                    <i class="fa-solid fa-tag-slash"></i>
                                  </span>
                                </span>

                                <!-- Hover Actions Group -->
                                <span class="memory-hover-actions">
                                  <!-- Linked Memories Button -->
                                  <button *ngIf="hasConversationId(memory) && !isEditingMemoryTag(memory)"
                                    class="memory-inline-btn memory-link-btn"
                                    (click)="searchByConversationId(memory, $event)" [disabled]="loading"
                                    title="Show linked memories from same conversation">
                                    <i class="fa-solid fa-link"></i>
                                  </button>

                                  <!-- Save/Cancel when editing -->
                                  <button *ngIf="isEditingMemoryTag(memory)" class="memory-inline-btn memory-save-btn"
                                    (click)="saveMemoryTagEdit(memory); $event.stopPropagation()" [disabled]="loading"
                                    title="Save">
                                    <i class="fa-solid fa-check"></i>
                                  </button>
                                  <button *ngIf="isEditingMemoryTag(memory)" class="memory-inline-btn memory-cancel-btn"
                                    (click)="cancelMemoryTagEdit(); $event.stopPropagation()" [disabled]="loading"
                                    title="Cancel">
                                    <i class="fa-solid fa-times"></i>
                                  </button>

                                  <!-- Delete Button -->
                                  <button *ngIf="!isShowingDeleteConfirmation(memory) && !isEditingMemoryTag(memory)"
                                    class="memory-inline-btn memory-delete-btn"
                                    (click)="showDeleteConfirmation(memory, $event)" [disabled]="loading"
                                    title="Delete memory">
                                    <i class="fa-solid fa-trash"></i>
                                  </button>

                                  <!-- Delete Confirmation (inline) -->
                                  <span *ngIf="isShowingDeleteConfirmation(memory)"
                                    class="memory-delete-confirm-inline">
                                    <button class="memory-inline-btn memory-confirm-delete-btn"
                                      (click)="deleteMemory(memory, $event)" [disabled]="loading"
                                      title="Confirm delete">
                                      <i class="fa-solid fa-check"></i>
                                    </button>
                                    <button class="memory-inline-btn memory-confirm-cancel-btn"
                                      (click)="cancelDelete(); $event.stopPropagation()" [disabled]="loading"
                                      title="Cancel">
                                      <i class="fa-solid fa-times"></i>
                                    </button>
                                  </span>
                                </span>
                              </div>
                            </div>
                          </div>

                          <!-- Load More Button -->
                          <div *ngIf="message.hasMore" style="margin-top: 12px; text-align: center;">
                            <button class="action-btn" (click)="loadMoreMemories(message)" [disabled]="loading"
                              aria-label="Load more memories">
                              <i class="fa-solid fa-chevron-down" aria-hidden="true"></i>
                              Load More
                            </button>
                          </div>

                          <!-- No Results -->
                          <div *ngIf="(!message.memories || message.memories.length === 0) && !message.showSkeletons"
                            class="no-results">
                            <p>No memories found matching this query.</p>
                          </div>
                        </div>
                      </div>

                      <!-- AI Summary Section -->
                      <div class="memory-summary-section"
                        *ngIf="(message.memorySummary || message.summaryLoading) && (message.displayMode === 'summary' || message.displayMode === 'summary_external')">
                        <div class="summary-header">
                          <span class="summary-badge" *ngIf="message.summaryLoading">
                            <span class="streaming-dot"></span>
                            {{ message.displayMode === 'summary_external' ? 'LIAM Thinking...' : 'LIAM Thinking...' }}
                          </span>
                        </div>

                        <div class="summary-content">
                          <!-- LIAM Neural Network Loading Animation -->
                          <div *ngIf="message.summaryLoading && !message.memorySummary" class="summary-loading">
                            <div class="liam-neural-container">
                              <div class="liam-hex-container">
                                <!-- Hexagon Nodes -->
                                <div class="liam-hex-node"></div>
                                <div class="liam-hex-node"></div>
                                <div class="liam-hex-node"></div>
                                <div class="liam-hex-node"></div>
                                <div class="liam-hex-node"></div>
                                <div class="liam-hex-node"></div>
                                <!-- Connection Lines -->
                                <div class="liam-hex-line"></div>
                                <div class="liam-hex-line"></div>
                                <div class="liam-hex-line"></div>
                                <div class="liam-hex-line"></div>
                                <div class="liam-hex-line"></div>
                                <div class="liam-hex-line"></div>
                                <!-- Center Icon -->
                                <div class="liam-hex-center">
                                  <i class="fa-solid fa-wand-magic-sparkles"></i>
                                </div>
                              </div>
                              <div class="liam-neural-label">
                                <i class="fa-solid fa-brain"></i>
                                {{ message.displayMode === 'summary_external' ? 'LIAM External AI...' : 'LIAM
                                Thinking...' }}
                              </div>
                            </div>
                          </div>

                          <!-- Summary Text (streams in with markdown rendering and token highlighting) -->
                          <div *ngIf="message.memorySummary" class="summary-text"
                            [innerHTML]="renderMarkdownWithTokens(message.memorySummary, message)"
                            (click)="onSummaryTokenClick($event, message)">
                          </div>
                          <span *ngIf="message.memorySummary && message.summaryLoading" class="typing-cursor">|</span>
                        </div>
                      </div>

                      <!-- Tags Display -->
                      <div class="tags-results" *ngIf="message.tags && message.tags.length > 0">
                        <div class="tags-header">
                          <span class="tags-count">{{ message.tags.length }} {{ message.tags.length === 1 ? 'tag' :
                            'tags' }}</span>
                        </div>
                        <div class="tags-list">
                          <div *ngFor="let tag of message.tags" class="tag-item" [class.editing]="isEditingTag(tag)">
                            <!-- View Mode -->
                            <ng-container *ngIf="!isEditingTag(tag)">
                              <button class="tag-btn" (click)="searchMemoriesByTag(tag)" [disabled]="loading">
                                <i class="fa-solid fa-tag" aria-hidden="true"></i>
                                {{ tag }}
                              </button>
                              <button class="tag-edit-btn" (click)="startEditingTag(tag)" [disabled]="loading"
                                title="Edit tag name">
                                <i class="fa-solid fa-pen"></i>
                              </button>
                            </ng-container>

                            <!-- Edit Mode -->
                            <ng-container *ngIf="isEditingTag(tag)">
                              <div class="tag-edit-form">
                                <input type="text" class="tag-edit-input" [(ngModel)]="editingTagNewName"
                                  (keydown.enter)="saveTagEdit(tag)" (keydown.escape)="cancelTagEdit()"
                                  [disabled]="loading" maxlength="50" placeholder="New tag name" />
                                <button class="tag-save-btn" (click)="saveTagEdit(tag)"
                                  [disabled]="loading || !editingTagNewName.trim()" title="Save">
                                  <i class="fa-solid fa-check"></i>
                                </button>
                                <button class="tag-cancel-btn" (click)="cancelTagEdit()" [disabled]="loading"
                                  title="Cancel">
                                  <i class="fa-solid fa-times"></i>
                                </button>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>

                      <!-- Empty Tags -->
                      <div *ngIf="message.tags && message.tags.length === 0" class="no-results">
                        <p>No tags found.</p>
                      </div>

                    </ng-container>
                  </div>
                </div>
              </div>

              <!-- System Message -->
              <div *ngIf="message.type === 'system'" class="message system" role="status"
                [class.info]="message.messageType === 'info'" [class.success]="message.messageType === 'success'"
                [class.warning]="message.messageType === 'warning'" [class.error]="message.messageType === 'error'">
                <div class="system-message-content">
                  <i class="fa-solid" [class.fa-info-circle]="message.messageType === 'info'"
                    [class.fa-check-circle]="message.messageType === 'success'"
                    [class.fa-exclamation-triangle]="message.messageType === 'warning'"
                    [class.fa-times-circle]="message.messageType === 'error'" aria-hidden="true"></i>
                  <span>{{ message.text }}</span>
                </div>
              </div>
            </ng-container>
          </div>

          <!-- Chat Input Area -->
          <div class="chat-input-area">
            <!-- Quick Access Tags (horizontal scroll) -->
            <div class="quick-access-tags" *ngIf="showQuickAccessTags && quickAccessTags.length > 0">
              <div class="quick-tags-scroll">
                <button *ngFor="let tag of quickAccessTags" class="quick-tag-btn" (click)="searchMemoriesByTag(tag)"
                  [disabled]="loading">
                  <i class="fa-solid fa-tag" aria-hidden="true"></i>
                  {{ tag }}
                </button>
              </div>
              <button class="quick-tags-toggle" (click)="toggleQuickAccessTags()" title="Hide tags">
                <i class="fa-solid fa-chevron-up"></i>
              </button>
            </div>

            <!-- Show Tags Button (when tags are hidden) -->
            <button *ngIf="!showQuickAccessTags && quickAccessTags.length > 0" class="show-tags-btn"
              (click)="toggleQuickAccessTags()" title="Show tags">
              <i class="fa-solid fa-tags"></i>
              <span>Show Tags</span>
              <i class="fa-solid fa-chevron-down"></i>
            </button>

            <div class="input-container">
              <div class="input-wrapper">
                <textarea class="chat-input" [(ngModel)]="query" placeholder="Search memories or ask a question..."
                  (keydown.enter)="$event.preventDefault(); sendMessage()" [disabled]="loading" rows="1"
                  aria-label="Search input" [attr.aria-invalid]="queryError ? 'true' : 'false'"></textarea>

                <div class="input-actions">
                  <!-- Unified Settings Menu (Option 1: Minimal + Overflow) -->
                  <div class="settings-dropdown">
                    <button class="input-action-btn settings-trigger"
                      [class.has-active]="betaMode || deepThinkingEnabled" (click)="toggleOptionsMenu($event)"
                      title="Settings & Options">
                      <i class="fa-solid fa-sliders"></i>
                    </button>

                    <div class="settings-menu" *ngIf="showOptionsMenu">
                      <!-- Mode Section -->
                      <div class="settings-section">
                        <div class="settings-section-header">
                          <i class="fa-solid fa-toggle-on"></i> Mode
                        </div>
                        <button class="settings-toggle-item" (click)="toggleBetaMode(); $event.stopPropagation()">
                          <span class="toggle-item-left">
                            <i class="fa-solid fa-flask"></i>
                            <span>Beta Mode</span>
                          </span>
                          <span class="toggle-switch" [class.active]="betaMode">
                            <span class="toggle-knob"></span>
                          </span>
                        </button>
                        <button class="settings-toggle-item" (click)="toggleDeepThinking(); $event.stopPropagation()"
                          [class.disabled]="!betaMode">
                          <span class="toggle-item-left">
                            <i class="fa-solid fa-brain"></i>
                            <span>Deep Thinking</span>
                          </span>
                          <span class="toggle-switch" [class.active]="deepThinkingEnabled && betaMode">
                            <span class="toggle-knob"></span>
                          </span>
                        </button>
                      </div>

                      <!-- Display Mode Section -->
                      <div class="settings-section">
                        <div class="settings-section-header">
                          <i class="fa-solid fa-eye"></i> Display
                        </div>
                        <div class="display-mode-grid">
                          <button class="display-mode-option" [class.active]="displayMode === 'raw'"
                            (click)="setDisplayMode('raw'); $event.stopPropagation()">
                            <i class="fa-solid fa-list"></i>
                            <span>Raw</span>
                          </button>
                          <button class="display-mode-option" [class.active]="displayMode === 'summarized'"
                            (click)="setDisplayMode('summarized'); $event.stopPropagation()">
                            <i class="fa-solid fa-layer-group"></i>
                            <span>Summarized</span>
                          </button>
                          <button class="display-mode-option" [class.active]="displayMode === 'summary'"
                            (click)="setDisplayMode('summary'); $event.stopPropagation()">
                            <i class="fa-solid fa-file-alt"></i>
                            <span>Summary</span>
                          </button>
                          <button class="display-mode-option" [class.active]="displayMode === 'summary_external'"
                            (click)="setDisplayMode('summary_external'); $event.stopPropagation()">
                            <i class="fa-solid fa-cloud"></i>
                            <span>External</span>
                          </button>
                        </div>
                      </div>

                      <!-- Persona Section -->
                      <div class="settings-section">
                        <div class="settings-section-header">
                          <i class="fa-solid fa-wand-magic-sparkles"></i> Summary Style
                        </div>
                        <div class="persona-grid">
                          <button *ngFor="let option of personaOptions" class="persona-option-compact"
                            [class.active]="summaryPersona === option.value"
                            (click)="setPersona(option.value); $event.stopPropagation()" [title]="option.description">
                            <i class="fa-solid {{ option.icon }}"></i>
                            <span>{{ option.label }}</span>
                          </button>
                        </div>
                      </div>

                      <!-- Actions Section -->
                      <div class="settings-section settings-actions">
                        <button class="settings-action-item" (click)="listAllMemories()">
                          <i class="fa-solid fa-list"></i> List All Memories
                        </button>
                        <button class="settings-action-item" (click)="listAllTags()">
                          <i class="fa-solid fa-tags"></i> List All Tags
                        </button>
                      </div>

                      <!-- Integrations Section -->
                      <div class="settings-section settings-integrations">
                        <div class="settings-section-header">
                          <i class="fa-solid fa-plug"></i> Integrations
                        </div>
                        <button class="settings-action-item" (click)="openMcpConfig()">
                          <i class="fa-solid fa-plug"></i> MCP Configuration
                        </button>
                        <button class="settings-action-item" (click)="openChromeConfig()">
                          <i class="fa-brands fa-chrome"></i> Chrome Extension
                        </button>
                        <button class="settings-action-item" (click)="showChromeOtp()">
                          <i class="fa-solid fa-key"></i> Show OTP
                        </button>
                        <button class="settings-action-item" (click)="openPerplexityMcpConfig()">
                          <i class="fa-solid fa-file-arrow-down"></i> Perplexity MCP
                        </button>
                      </div>

                      <!-- Danger Zone -->
                      <div class="settings-section settings-danger">
                        <button class="settings-action-item" (click)="exportChat()">
                          <i class="fa-solid fa-download"></i> Export Chat
                        </button>
                        <button class="settings-action-item danger" (click)="clearChat()">
                          <i class="fa-solid fa-trash"></i> Clear Chat
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Send Button -->
                  <button class="send-btn" (click)="sendMessage()" [disabled]="loading || !query.trim()"
                    aria-label="Send message">
                    <i *ngIf="!loading" class="fa-solid fa-paper-plane"></i>
                    <i *ngIf="loading" class="fa-solid fa-spinner fa-spin"></i>
                  </button>
                </div>
              </div>

              <!-- Active Mode Indicators (below input box) -->
              <div class="active-mode-indicators" *ngIf="betaMode || displayMode !== 'raw'">
                <span class="mode-pill beta" *ngIf="betaMode">
                  <i class="fa-solid fa-flask"></i> Beta
                </span>
                <span class="mode-pill deep" *ngIf="betaMode && deepThinkingEnabled">
                  <i class="fa-solid fa-brain"></i> Deep
                </span>
                <span class="mode-pill display">
                  <i class="fa-solid {{ getDisplayModeIcon() }}"></i> {{ getDisplayModeText() }}
                </span>
              </div>

              <div class="input-error" *ngIf="queryError">
                {{ queryError }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- MCP Configuration Modal -->
<div class="modal-overlay" *ngIf="showMcpModal" (click)="closeMcpConfig()">
  <div class="modal-content mcp-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2><i class="fa-solid fa-plug"></i> MCP Configuration</h2>
      <button class="modal-close" (click)="closeMcpConfig()">
        <i class="fa-solid fa-times"></i>
      </button>
    </div>
    <div class="modal-body">
      <p class="mcp-description">
        Connect Claude Desktop to your memory system using MCP (Model Context Protocol).
      </p>

      <div class="config-item">
        <label>Connector Name</label>
        <div class="config-value">
          <code>{{ mcpConfig.CONNECTOR_NAME }}</code>
          <button class="copy-btn" (click)="copyConnectorName()">
            <i class="fa-solid fa-copy"></i>
          </button>
        </div>
      </div>

      <div class="config-item">
        <label>MCP URL</label>
        <div class="config-value">
          <code>{{ mcpConfig.MCP_URL }}</code>
          <button class="copy-btn" (click)="copyMcpUrl()">
            <i class="fa-solid fa-copy"></i>
          </button>
        </div>
      </div>

      <div class="mcp-instructions">
        <h3>Setup Instructions</h3>
        <ol>
          <li>Open Claude Desktop settings</li>
          <li>Navigate to the MCP integrations section</li>
          <li>Add a new integration with the connector name above</li>
          <li>Paste the MCP URL in the endpoint field</li>
          <li>Save and restart Claude Desktop</li>
        </ol>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn-secondary" (click)="closeMcpConfig()">Close</button>
      <button class="btn-primary" (click)="openClaudeDesktop()">
        <i class="fa-solid fa-external-link-alt"></i>
        Open Claude Desktop
      </button>
    </div>
  </div>
</div>

<!-- Chrome Extension Configuration Modal -->
<div class="modal-overlay" *ngIf="showChromeModal" (click)="closeChromeConfig()">
  <div class="modal-content chrome-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2><i class="fa-brands fa-chrome"></i> Chrome Extension Setup</h2>
      <button class="modal-close" (click)="closeChromeConfig()">
        <i class="fa-solid fa-times"></i>
      </button>
    </div>
    <div class="modal-body chrome-modal-body">
      <p class="chrome-description">
        Install the LIAM Memory Assistant Chrome extension to capture and save memories directly from your browser.
      </p>

      <div class="chrome-config-section">
        <h3>Your Configuration</h3>

        <div class="config-item">
          <label>Base URL</label>
          <div class="config-value">
            <code>{{ chromeConfig.BASE_URL }}</code>
            <button class="copy-btn" (click)="copyChromeBaseUrl()">
              <i class="fa-solid fa-copy"></i>
            </button>
          </div>
        </div>

        <div class="config-item">
          <label>Your Email</label>
          <div class="config-value">
            <code>{{ getChromeUserEmail() }}</code>
            <button class="copy-btn" (click)="copyChromeEmail()">
              <i class="fa-solid fa-copy"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="chrome-setup-steps">
        <h3>Setup Steps</h3>
        <div class="chrome-steps">
          <div class="chrome-step">
            <span class="step-number">1</span>
            <div class="step-content">
              <strong>Install Extension</strong>
              <p>Click the button below to install from Chrome Web Store</p>
            </div>
          </div>
          <div class="chrome-step">
            <span class="step-number">2</span>
            <div class="step-content">
              <strong>Enter Base URL</strong>
              <p>Copy the Base URL above and paste it in the extension settings</p>
            </div>
          </div>
          <div class="chrome-step">
            <span class="step-number">3</span>
            <div class="step-content">
              <strong>Authenticate</strong>
              <p>Enter your email and use the OTP sent to verify</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn-secondary" (click)="closeChromeConfig()">Close</button>
      <button class="btn-primary" (click)="openChromeStore()">
        <i class="fa-brands fa-chrome"></i>
        Install Extension
      </button>
    </div>
  </div>
</div>